module.exports = __webpack_public_path__ + "img/Tail_feathers_Normal.56ead4c.png";